import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const { user } = useSelector((state) => state.user);
  const isProjectManager = user?.data?.position?.name === "Project Manager";
  const { projectId } = useParams();

  if (!isProjectManager) {
    return <Navigate to={`/projeler/edit/${projectId}`} replace />;
  }

  return children;
};

export default ProtectedRoute;
